export const _getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const _createParameterObject = (parseType, keyValue) => {
    /*
    This function is called with two argument and returns an object
    containing the url query parameter and values
    if no values are given then it returns an empty object
      */
    let queryString = window.location.search.slice(1);
    let queryArray = queryString.split('&');
    let queryObj = {};

    for (let array of queryArray) {
        let tempArray = array.split('=');
        if (keyValue === tempArray[0]) {
            if(parseType === 'camelBack') {
                queryObj[tempArray[0]] = parseCamelBack(tempArray[1]);
            }
        } else {
            queryObj[tempArray[0]] = tempArray[1];
        }
    }
    return queryObj;
};

const parseCamelBack = (word) => {
    /*
        This function takes in a word and parses the camelBack into
        a string with a space separating each capitalized word.
     */
    if (word.includes('-')){
        word = word.replace('-', '');
        return word.split('to').join(' to ');
    } else {
        const regex = /[A-Z]/g;
        let newWord = [];

        //foundCharacters will be an array of capitalized characters that exist in the string.
        const foundCharacters = word.match(regex);
        let tempWord = word;

        //if there is only one letter in the array we don't need to do anything and just return the string
        if (foundCharacters.length === 1) {
            return word;
        } else {
            //This for loop iterates through the found characters and places
            //the words in the tempWord array
            for (let index = 0; index < foundCharacters.length; index++) {
                let startInd, endInd;
                if (index) {
                    startInd = tempWord.indexOf(foundCharacters[index]);
                    endInd = tempWord.indexOf(foundCharacters[index + 1]) !== -1 ? tempWord.indexOf(foundCharacters[index + 1]) : tempWord.length;
                    //Checks if we have the same capitalized letter
                    endInd = startInd === endInd ? tempWord.slice(1).indexOf(foundCharacters[index +1]) + 1 : endInd;
                } else {
                    startInd = 0;
                    endInd = tempWord.indexOf(foundCharacters[index +1]) ? tempWord.indexOf(foundCharacters[index +1]) : tempWord.slice(1).indexOf(foundCharacters[index +1]) + 1;
                }
                newWord.push(tempWord.slice(startInd, endInd));
                //to avoid any mix ups with any other words we slice the tempWord
                //so if the word has two of the same capitalized letters there is no mixup in past words
                tempWord = tempWord.slice(endInd);
            }
        }
        return newWord.join(' ');
    }
};


export const convertQueryParamsStringToQueryParamsObject = (string) => {
    let queryParams = {};
    if(string){
        string = string.substring(1);
        const queryParamsArray = string.split('&');
        queryParamsArray.forEach((queryParam) => {
            const queryParamArray = queryParam.split('=');
            queryParams[queryParamArray[0]] = queryParamArray[1];
        });
    }

    return queryParams;
};

/**
 * Returns cleaned query parameters to avoid any null values.
 * @param {URLSearchParams} params - The query parameters.
 * @returns {Object} - The parsed query parameters object that converts string null | undefined to null.
 * @example
 * Returns { "coverageYear": "2025", "applicationType": "QEP", "caseNumber": null }
 */
export const cleanQueryParams = (params) => {
    const cleanedParams = {};
    params.forEach((value, key) => {
        cleanedParams[key] = value === 'null' || value === 'undefined' ? null : value;
    });
    return cleanedParams;
};